// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__UPQ8s {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: var(--PAGE_MAX_WIDTH);
  min-height: var(--SIZE_400);
  background: var(--COLOR_FOREGROUND);
  border-radius: var(--RADIUS_12);
}

.styles_headerBlock__xshX6 {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: var(--PADDING_24) var(--PADDING_24) var(--PADDING_20);
  /* border-bottom: var(--SIZE_BORDER) solid var(--COLOR_PRIMARY_350); */
}

.styles_textBlock__FueGG {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 0 var(--PADDING_10);
}

.styles_titleStyle__eEvMT {
  padding-bottom: var(--PADDING_4);
  font-family: var(--FONT_SEMIBOLD);
  font-style: normal;
  font-weight: var(--WEIGHT_600);
  font-size: var(--FONT_SIZE_24);
  line-height: var(--LINE_HEIGHT_28);
  text-align: center;
}

.styles_subTitleStyle__gvl1H {
  font-family: var(--FONT_DEFAULT);
  font-style: normal;
  font-weight: var(--WEIGHT_400);
  font-size: var(--FONT_SIZE_TEXT);
  line-height: var(--LINE_HEIGHT_20);
  color: var(--COLOR_GRAY_600);
  margin: var(--MARGIN_10) 0;
}

.styles_closeStyle__an2Du {
  padding: 0;
  border: 0;
  background: none;
  align-self: center;
  cursor: pointer;
}

.styles_mainBlock__QdR5\\+ {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: var(--PADDING_24);
  /* border-bottom: var(--SIZE_BORDER) solid var(--COLOR_PRIMARY_350); */
}

/* .titleStyle {
  padding-bottom: var(--PADDING_4);
  font-family: var(--FONT_SEMIBOLD);
  font-style: normal;
  font-weight: var(--WEIGHT_600);
  font-size: var(--FONT_SIZE_TEXT_TITLE);
  line-height: var(--LINE_HEIGHT_28);
} */

.styles_subTitleStyle__gvl1H {
  font-family: var(--FONT_DEFAULT);
  font-style: normal;
  font-weight: var(--WEIGHT_400);
  font-size: var(--FONT_SIZE_TEXT);
  line-height: var(--LINE_HEIGHT_20);
  color: var(--COLOR_GRAY_600);
}

/* .titleStyle {
  padding-bottom: var(--PADDING_4);
  font-family: var(--FONT_SEMIBOLD);
  font-style: normal;
  font-weight: var(--WEIGHT_600);
  font-size: var(--FONT_SIZE_TEXT_TITLE);
  line-height: var(--LINE_HEIGHT_28);
} */

.styles_inputStyle__hDJ3R {
  padding: var(--PADDING_10) var(--PADDING_14);
  height: var(--SIZE_30);
  margin-bottom: var(--MARGIN_20);
  font-size: var(--FONT_SIZE_SUB_TITLE);
}

.styles_inputStyle__hDJ3R::placeholder {
  font-family: var(--FONT_DEFAULT);
  font-style: normal;
  font-weight: var(--WEIGHT_400);
  font-size: var(--FONT_SIZE_SUB_TITLE);
  line-height: var(--LINE_HEIGHT_24);
  color: var(--COLOR_GRAY_500_LIGHT);
}

.styles_inputBlock__eM7MD {
  margin-top: 10px;
}
.styles_footerBlock__Be8YJ {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: var(--PADDING_24);
}

.styles_selectPopupStyle__fs\\+em {
  position: relative;
  z-index: 2501 !important;
  width: 100%;
}

/* .selectStyle {
  z-index: 2501 !important;
} */
`, "",{"version":3,"sources":["webpack://./src/components/routes/modals/ReasonModal/styles.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,4BAA4B;EAC5B,2BAA2B;EAC3B,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,8DAA8D;EAC9D,sEAAsE;AACxE;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;EACjC,kBAAkB;EAClB,8BAA8B;EAC9B,8BAA8B;EAC9B,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,8BAA8B;EAC9B,gCAAgC;EAChC,kCAAkC;EAClC,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,sEAAsE;AACxE;;AAEA;;;;;;;GAOG;;AAEH;EACE,gCAAgC;EAChC,kBAAkB;EAClB,8BAA8B;EAC9B,gCAAgC;EAChC,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;;;;;;;GAOG;;AAEH;EACE,4CAA4C;EAC5C,sBAAsB;EACtB,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,8BAA8B;EAC9B,qCAAqC;EACrC,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,WAAW;AACb;;AAEA;;GAEG","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  width: var(--PAGE_MAX_WIDTH);\n  min-height: var(--SIZE_400);\n  background: var(--COLOR_FOREGROUND);\n  border-radius: var(--RADIUS_12);\n}\n\n.headerBlock {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  padding: var(--PADDING_24) var(--PADDING_24) var(--PADDING_20);\n  /* border-bottom: var(--SIZE_BORDER) solid var(--COLOR_PRIMARY_350); */\n}\n\n.textBlock {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  padding: 0 var(--PADDING_10);\n}\n\n.titleStyle {\n  padding-bottom: var(--PADDING_4);\n  font-family: var(--FONT_SEMIBOLD);\n  font-style: normal;\n  font-weight: var(--WEIGHT_600);\n  font-size: var(--FONT_SIZE_24);\n  line-height: var(--LINE_HEIGHT_28);\n  text-align: center;\n}\n\n.subTitleStyle {\n  font-family: var(--FONT_DEFAULT);\n  font-style: normal;\n  font-weight: var(--WEIGHT_400);\n  font-size: var(--FONT_SIZE_TEXT);\n  line-height: var(--LINE_HEIGHT_20);\n  color: var(--COLOR_GRAY_600);\n  margin: var(--MARGIN_10) 0;\n}\n\n.closeStyle {\n  padding: 0;\n  border: 0;\n  background: none;\n  align-self: center;\n  cursor: pointer;\n}\n\n.mainBlock {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  padding: var(--PADDING_24);\n  /* border-bottom: var(--SIZE_BORDER) solid var(--COLOR_PRIMARY_350); */\n}\n\n/* .titleStyle {\n  padding-bottom: var(--PADDING_4);\n  font-family: var(--FONT_SEMIBOLD);\n  font-style: normal;\n  font-weight: var(--WEIGHT_600);\n  font-size: var(--FONT_SIZE_TEXT_TITLE);\n  line-height: var(--LINE_HEIGHT_28);\n} */\n\n.subTitleStyle {\n  font-family: var(--FONT_DEFAULT);\n  font-style: normal;\n  font-weight: var(--WEIGHT_400);\n  font-size: var(--FONT_SIZE_TEXT);\n  line-height: var(--LINE_HEIGHT_20);\n  color: var(--COLOR_GRAY_600);\n}\n\n/* .titleStyle {\n  padding-bottom: var(--PADDING_4);\n  font-family: var(--FONT_SEMIBOLD);\n  font-style: normal;\n  font-weight: var(--WEIGHT_600);\n  font-size: var(--FONT_SIZE_TEXT_TITLE);\n  line-height: var(--LINE_HEIGHT_28);\n} */\n\n.inputStyle {\n  padding: var(--PADDING_10) var(--PADDING_14);\n  height: var(--SIZE_30);\n  margin-bottom: var(--MARGIN_20);\n  font-size: var(--FONT_SIZE_SUB_TITLE);\n}\n\n.inputStyle::placeholder {\n  font-family: var(--FONT_DEFAULT);\n  font-style: normal;\n  font-weight: var(--WEIGHT_400);\n  font-size: var(--FONT_SIZE_SUB_TITLE);\n  line-height: var(--LINE_HEIGHT_24);\n  color: var(--COLOR_GRAY_500_LIGHT);\n}\n\n.inputBlock {\n  margin-top: 10px;\n}\n.footerBlock {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  padding: var(--PADDING_24);\n}\n\n.selectPopupStyle {\n  position: relative;\n  z-index: 2501 !important;\n  width: 100%;\n}\n\n/* .selectStyle {\n  z-index: 2501 !important;\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__UPQ8s`,
	"headerBlock": `styles_headerBlock__xshX6`,
	"textBlock": `styles_textBlock__FueGG`,
	"titleStyle": `styles_titleStyle__eEvMT`,
	"subTitleStyle": `styles_subTitleStyle__gvl1H`,
	"closeStyle": `styles_closeStyle__an2Du`,
	"mainBlock": `styles_mainBlock__QdR5+`,
	"inputStyle": `styles_inputStyle__hDJ3R`,
	"inputBlock": `styles_inputBlock__eM7MD`,
	"footerBlock": `styles_footerBlock__Be8YJ`,
	"selectPopupStyle": `styles_selectPopupStyle__fs+em`
};
export default ___CSS_LOADER_EXPORT___;
